import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { translations } from "../i18n/translations";
import { extraTranslations } from "../i18n/extra";

const I18nContext = createContext(null);

const getByPath = (obj, path) => {
  if (!obj) return undefined;
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
};

const interpolate = (template, vars) => {
  if (!vars) return template;
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) =>
    vars[key] === undefined || vars[key] === null ? "" : String(vars[key])
  );
};

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "tr");

  const setLang = useCallback((next) => {
    const normalized = next === "en" ? "en" : "tr";
    localStorage.setItem("lang", normalized);
    setLangState(normalized);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const langTable = translations[lang] || translations.tr;
      const fallbackTable = translations.tr;
      const value =
        getByPath(langTable, key) ??
        getByPath(extraTranslations[lang], key) ??
        getByPath(fallbackTable, key) ??
        getByPath(extraTranslations.tr, key) ??
        key;
      if (typeof value !== "string") return key;
      return interpolate(value, vars);
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};

